
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.77083 11.3125H11.0208V6.04167H9.77083V11.3125ZM10.3333 14.5C10.5278 14.5 10.691 14.434 10.8229 14.3021C10.9549 14.1701 11.0208 14.0069 11.0208 13.8125C11.0208 13.6181 10.9549 13.4549 10.8229 13.3229C10.691 13.191 10.5278 13.125 10.3333 13.125C10.1389 13.125 9.9757 13.191 9.84375 13.3229C9.71181 13.4549 9.64583 13.6181 9.64583 13.8125C9.64583 14.0069 9.71181 14.1701 9.84375 14.3021C9.9757 14.434 10.1389 14.5 10.3333 14.5ZM10.3333 18.6667C9.15278 18.6667 8.05556 18.4549 7.04167 18.0312C6.02778 17.6076 5.14583 17.0208 4.39583 16.2708C3.64583 15.5208 3.05903 14.6389 2.63542 13.625C2.21181 12.6111 2 11.5139 2 10.3333C2 9.16667 2.21181 8.07639 2.63542 7.0625C3.05903 6.04861 3.64583 5.16667 4.39583 4.41667C5.14583 3.66667 6.02778 3.07639 7.04167 2.64583C8.05556 2.21528 9.15278 2 10.3333 2C11.5 2 12.5903 2.21528 13.6042 2.64583C14.6181 3.07639 15.5 3.66667 16.25 4.41667C17 5.16667 17.5903 6.04861 18.0208 7.0625C18.4514 8.07639 18.6667 9.16667 18.6667 10.3333C18.6667 11.5139 18.4514 12.6111 18.0208 13.625C17.5903 14.6389 17 15.5208 16.25 16.2708C15.5 17.0208 14.6181 17.6076 13.6042 18.0312C12.5903 18.4549 11.5 18.6667 10.3333 18.6667ZM10.3333 17.4167C12.2778 17.4167 13.9444 16.7222 15.3333 15.3333C16.7222 13.9444 17.4167 12.2778 17.4167 10.3333C17.4167 8.38889 16.7222 6.72222 15.3333 5.33333C13.9444 3.94444 12.2778 3.25 10.3333 3.25C8.38889 3.25 6.72222 3.94444 5.33333 5.33333C3.94444 6.72222 3.25 8.38889 3.25 10.3333C3.25 12.2778 3.94444 13.9444 5.33333 15.3333C6.72222 16.7222 8.38889 17.4167 10.3333 17.4167Z","fill":"#191919"}})])
          )
        }
      }
    